<script>
  import { currentScreen, currentUser, authInitialized } from './svelte/store.js';
  import Home from './svelte/screens/Home.svelte';
  import Setup from './svelte/screens/Setup.svelte';
  import Players from './svelte/screens/Players.svelte';
  import Break from './svelte/screens/Break.svelte';
  import Result from './svelte/screens/Result.svelte';
  import Settings from './svelte/screens/Settings.svelte';
  import RecorderJoin from './svelte/screens/RecorderJoin.svelte';
  import Schedule from './svelte/screens/Schedule.svelte';
  import Scoring from './svelte/screens/Scoring.svelte';
  import RecorderScreen from './svelte/screens/RecorderScreen.svelte';
  import Tournaments from './svelte/screens/Tournaments.svelte';
  import Teams from './svelte/screens/Teams.svelte';
  import Ecosystem from './svelte/screens/Ecosystem.svelte';
  import CloudTournaments from './svelte/screens/CloudTournaments.svelte';
  import SetupChallenge from './svelte/screens/SetupChallenge.svelte';
  import LoginModal from './svelte/components/LoginModal.svelte';
  import PremiumModal from './svelte/components/PremiumModal.svelte';
  import DialogHost from './svelte/components/DialogHost.svelte';
  import Profile from './svelte/screens/Profile.svelte';
  import SpectatorScreen from './svelte/screens/SpectatorScreen.svelte';
  import { go } from './router.js';
  import { showLoginModal, showPremiumModal, guestMode, deviceCheckOpen, recordingSafetyOpen } from './svelte/store.js';
  import { dialogState } from './ui/dialogs.js';
  // Sync-queue wiring lives in main.js (runs even if the app is force-update
  // gated) — no duplicate init here, or the 'online' listener registers twice.

  // FOCUS TRAP for the modals rendered OUTSIDE .svelte-root (DialogHost,
  // LoginModal, PremiumModal). They block the mouse with a fixed z-index
  // overlay, but Tab still reached the screen underneath — a user could Tab to
  // a scoring-pad button and press Enter while a dialog was open. `inert`
  // removes the screen from the tab order and the a11y tree.
  //
  // NOTE: $modalState (MatchModals) is deliberately NOT included — that
  // component renders *inside* .svelte-root, so inerting the root would disable
  // the modal itself. It needs a use:focusTrap action on its own overlay.
  $: uiBlocked = !!$dialogState || $showLoginModal || $showPremiumModal || $deviceCheckOpen || $recordingSafetyOpen;
</script>

<div class="svelte-root" inert={uiBlocked || undefined} aria-hidden={uiBlocked || undefined}>
  {#if !$authInitialized}
    <div class="auth-loading">
      <div class="spinner"></div>
      <p>Loading Cricket Scorer...</p>
    </div>
  {:else if !$currentUser && !$guestMode}
    <LoginModal cancellable={false} allowGuest={true} />
  {:else}
    {#if $currentScreen === 'home'}
      <Home />
    {:else if $currentScreen === 'setup'}
      <Setup />
    {:else if $currentScreen === 'setup-challenge'}
      <SetupChallenge />
    {:else if $currentScreen === 'players'}
      <Players />
    {:else if $currentScreen === 'break'}
      <Break />
    {:else if $currentScreen === 'result'}
      <Result />
    {:else if $currentScreen === 'settings'}
      <Settings />
    {:else if $currentScreen === 'recorder-join'}
      <RecorderJoin />
    {:else if $currentScreen === 'schedule'}
      <Schedule />
    {:else if $currentScreen === 'tournaments'}
      <Tournaments />
    {:else if $currentScreen === 'teams'}
      <Teams />
    {:else if $currentScreen === 'ecosystem'}
      <Ecosystem />
    {:else if $currentScreen === 'cloud-tournaments'}
      <CloudTournaments />
    {:else if $currentScreen === 'scoring'}
      <Scoring />
    {:else if $currentScreen === 'recording'}
      <RecorderScreen />
    {:else if $currentScreen === 'profile'}
      <Profile />
    {:else if $currentScreen === 'spectator'}
      <SpectatorScreen onBack={() => go('home')} />
    {:else}
      <Home />
    {/if}
  {/if}
</div>

{#if $showLoginModal}
  <LoginModal on:close={() => showLoginModal.set(false)} />
{/if}

{#if $showPremiumModal}
  <PremiumModal on:close={() => showPremiumModal.set(false)} />
{/if}

<!-- App-styled toast + confirm/prompt host (replaces window.alert/confirm/prompt) -->
<DialogHost />

<style>
  .svelte-root {
    width: 100%;
    height: 100%;
    display: flex;
    flex-direction: column;
    overflow: hidden;
  }
  .auth-loading {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    height: 100%;
    background: #0d1b2a;
    color: white;
  }
  .spinner {
    width: 40px;
    height: 40px;
    border: 4px solid rgba(255, 255, 255, 0.3);
    border-radius: 50%;
    border-top-color: #4CAF50;
    animation: spin 1s ease-in-out infinite;
    margin-bottom: 20px;
  }
  @keyframes spin {
    to { transform: rotate(360deg); }
  }
</style>
